import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  const [activeTab, setActiveTab] = useState('intro');

  return (
    <div className="about-page">
      {/* 页面头部 */}
      <div className="page-header-about">
        <div className="header-bg-about">
          <div className="header-content-about">
            <h1>关于棱讯 <span className="en-title-about">About us</span></h1>
            <div className="breadcrumb-about">
              <Link to="/">首页</Link> &gt; <Link to="/about">关于棱讯</Link> &gt; {activeTab === 'intro' ? '公司简介' : '联系我们'}
            </div>
          </div>
        </div>
      </div>

      {/* 关于导航 - 改为与产品页相似的标签样式 */}
      <div className="about-tabs">
        <div className="tab-container-about">
          <div
            className={`tab ${activeTab === 'intro' ? 'active' : ''}`}
            onClick={() => setActiveTab('intro')}
          >
            <span className="tab-icon intro-icon"></span>公司简介
          </div>
          <div className="tab-divider"></div>
          <div
            className={`tab ${activeTab === 'contact' ? 'active' : ''}`}
            onClick={() => setActiveTab('contact')}
          >
            <span className="tab-icon head-contact-icon"></span>联系我们
          </div>
        </div>
      </div>

      {/* 内容区域 - 使用条件渲染 */}
      <div className="about-container">
        <div className="about-content">
          {activeTab === 'intro' && (
            <>
              <div className="about-header">
                <h2>棱讯简介</h2>
                <h3 className="en-title-about">LX INTRODUCTION</h3>
              </div>

              <div className="company-info">
                <h3>南京棱讯信息技术有限公司（简称棱讯）</h3>
                <p className="company-description">
                  成立于2018年，是一家专注于网络视讯技术研究、产品开发、销售及整体视频通讯系统解决方案的技术型企业。​公司致力于为电力、教育、政企等行业提供高效的远程协作和沟通解决方案，产品涵盖视频会议、流媒体（点播/直播）和教育录播/互动教学系统。
                </p>
                <p className="company-description">
                  公司服务形式包括产品OEM、软件授权和软件定制，满足不同客户的个性化需求。凭借丰富的行业经验和技术积累，南京棱讯不断推动视讯技术的创新与应用，助力各行业实现数字化转型。
                </p>
              </div>
            </>
          )}

          {activeTab === 'contact' && (
            <>
              <div className="about-header">
                <h2>联系我们</h2>
                <h3 className="en-title-about">CONTACT US</h3>
              </div>

              <div className="contact-info-container">
                <div className="contact-card">
                  <div className="contact-icon phone-icon"></div>
                  <h3>电话咨询</h3>
                  <p>工作时间：周一至周五 9:00-18:00</p>
                  <div className="contact-value no-call-phone">屠先生 18761618734</div>
                  <a href="tel:+8618761618734" className="contact-value call-phone">屠先生 18761618734</a>
                </div>

                <div className="contact-card">
                  <div className="contact-icon email-icon"></div>
                  <h3>邮件咨询</h3>
                  <p>我们会在24小时内回复您的邮件</p>
                  <div className="contact-value">415929165@qq.com</div>
                </div>

                <div className="contact-card">
                  {/* <div className="contact-icon wechat-icon"></div> */}
                  <h3>微信咨询</h3>
                  <p>扫描下方二维码添加微信咨询</p>
                  <div className="wechat-qrcode">
                    <img src="/images/allen.jpg" alt="微信二维码" />
                  </div>
                </div>
              </div>

              {/* <div className="company-address">
                <h3>公司地址</h3>
                <p>南京市...</p>
                <div className="map-container">
                  <div className="map-placeholder">
                    地图加载中...
                  </div>
                </div>
              </div> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default About;